import { Button } from "components/Atoms/Button";
import { PhosphorCheck, PhosphorX } from "components/Atoms/PhosphorIcon";
import React from "react";
import { AdvancingFieldLabel } from "./AdvancingFieldLabel";
import { InPageEditableField } from "./InPageEditableField";
import { AdvancingApproveSectionField } from "./types";

interface Props {
  field: AdvancingApproveSectionField
}

export const AdvancingApproveFieldWithLabel = ({ field }: Props) => {
  const value = <InPageEditableField compact={false} field={{ ...field, valueClassName: field.formElementBehavior === "visibleMandatory" ? "advancing-mandatory-field" : undefined }} />;

  return <>
    <AdvancingFieldLabel field={field} onRemove={field.onRemove} />
    {field.onValueClick
      ? <div onClick={field.onValueClick}>{value}</div>
      : value}
    <div className="flex gap-small">
      {field.approveButtons.isVisible && <>
        <Button type="primary" iconRight={PhosphorCheck} loading={field.approveButtons.isApproving} onClick={field.approveButtons.onApprove} />
        <Button type="warning" iconRight={PhosphorX} loading={field.approveButtons.isDeclining} onClick={field.approveButtons.onDecline} />
      </>}
    </div>
  </>;
};
